<div class="file-list-explorer-with-selected-list-wrapper">
  <div class="file-explorer-select-list">
    <rappider-file-explorer [activeEntityData]="activeEntityData"
                        [listGridConfig]="listGridConfig"
                        [selectedItem]="selectedItem"
                        [loading]="loading"
                        [submitButtonLoading]="submitButtonLoading"
                        [buttonConfig]="buttonConfig"
                        [alertConfig]="alertConfig"
                        [folderOrder]="folderOrder"
                        (searchTextChange)="onSearchTextChange($event)"
                        (rowActionClick)="onRowActionClick($event)"
                        (overflowlistItemClick)="onOverflowlistItemClick($event)"
                        (selectionChange)="onSelectionChange($event)"
                        (buttonClick)="onButtonClick()"></rappider-file-explorer>
  </div>
  <div class="button-group">
    <rappider-icon [name]="'fa-regular fa-angles-right'"
                   [color]="'var(--placeholder-color)'"
                   [size]="'2rem'"></rappider-icon>
  </div>
  <div class="file-explorer-selected-list">
    <rappider-file-explorer [activeEntityData]="selectedData"
                            [listGridConfig]="selectedListGridConfig"
                            [editFormConfig]="editFormConfig"
                            [selectedItem]="selectedItem"
                            [loading]="false"
                            [submitButtonLoading]="submitButtonLoading"
                            [buttonConfig]="selectedButtonConfig"
                            [alertConfig]="selectedFileListInfoAlertConfig"
                            [folderOrder]="folderOrder"
                            [editFormVisible]="selectedListEditFormVisible"
                            (searchTextChange)="onSearchTextChange($event)"
                            (rowActionClick)="onRowActionClick($event)"
                            (overflowlistItemClick)="onOverflowlistItemClick($event)"
                            (selectionChange)="onSelectedListSelectionChange($event)"
                            (formValueChange)="onFormValueChange($event)"
                            (buttonClick)="onButtonClick()"></rappider-file-explorer>
  </div>
</div>
